function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.625 5.78l-.004.004-.014.01-.059.049a42.76 42.76 0 00-1.111.952c-.744.66-1.772 1.611-2.908 2.778-2.283 2.345-4.952 5.508-6.635 8.874a1 1 0 01-1.788 0 8.015 8.015 0 00-2.278-2.78 6.882 6.882 0 00-.893-.586 4.422 4.422 0 00-.303-.15l-.008-.004h.002l.001.001m-.003-.001a1 1 0 01.747-1.855L5 14l.371-.928.004.001.004.002.012.005.034.014.108.048c.089.042.211.102.36.183.297.162.701.409 1.154.757a9.928 9.928 0 011.898 1.929c1.78-3.03 4.145-5.773 6.151-7.834A57.484 57.484 0 0118.11 5.3a44.66 44.66 0 011.172-1.004l.067-.055.019-.015.006-.005L20 5l-.625-.78a1 1 0 011.25 1.56",
  fill: "#9F864E"
});

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default ForwardRef;